export default __webpack_public_path__ + "media/zurb/img/ecommerce/bn_3-9f19d55882fc8ae7f3ee3e2e7356326e.png";